import React, { useEffect, useState } from "react";
import { useNotify, Loading } from 'react-admin';
import { getDate, weekDays, getDayText } from '../calendar';
import { findOrderOfDay, getDayOrdersCount, getDeliveryGroupColor } from "../order-schedule/functions";
import { handleSchedulesResult } from './functions';
import { reqSchedules } from './api';

import styles from './WeeklySchedules.module.css';

const WeeklySchedules = ({ today }) => {
  
  const notify = useNotify();

  // data
  const [ data, setData ] = useState({ week: [], orders: [] });

  // additional states 
  const [ loading, setLoading ] = useState(false);

  useEffect(() => {
    const errorMsg = '데이터 로딩에 실패했습니다. 관리자에게 문의해주세요.';

    const fetchData = async () => {
      try {
        setLoading(true);

        // load dashboard data 
        const { data: resultData } = await reqSchedules();
    
        setData({
          week: weekDays(getDate(today)),
          orders: handleSchedulesResult(resultData)
        });    
        
        setLoading(false);
      } catch (err) {
        setLoading(false);
        notify(errorMsg, 'error');
        console.error(err);
      }
    };

    fetchData();

  }, [ today ]);

  return (
    <div>
      <div>스케줄</div>
      {loading ? (
      <Loading />
      ): (
      <WeekView
        week={data.week ?? []}
        orders={data.orders}
      />
      )}
    </div>
  );
}

const WeekView = ({ week, orders }) => {

  return (
    <div className={styles.weekRow}>
      {/* bg */}
      <div className={styles.weekRowBg}>
        <div className={styles.customerColumn} />
        {week.map((day, i) => (
          <div key={i} className={styles.orderColumn} />
        ))}
      </div>
      {/* header */}
      <div className={styles.weekHeaderRow}>
        <div className={styles.customerColumn} />
        {week.map((day, i) => (
          <div
            key={i}
            className={styles.orderColumn}
          >
            <div className={styles.weekHeader}>
              {getDayText(day, false)}
            </div>
            <div className={styles.weekHeader}>
              {day.getDate()}
            </div>
          </div>
        ))}
      </div>
      {/* orders */}
      {orders.map((customerOrders, i) => (
        <CustomerOrders
          key={i}
          customerOrders={customerOrders}
          week={week}
        />
      ))}
      {/* footer */}
      <div className={styles.weekFooterRow}>
        <div className={styles.customerColumn} />
        {week.map((day, i) => (
          <div
            key={i}
            className={styles.orderColumn}
          >
            <div className={styles.weekFooter}>
              <div>총계</div>
              <div className={styles.dayOrderCount}>{getDayOrdersCount(orders, day)}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

const CustomerOrders = ({ customerOrders, week }) => {
  
  return (
    <div 
      className={styles.customerOrderRow}
      style={{
        backgroundColor: getDeliveryGroupColor(customerOrders.deliveryGroup)
      }}
    >
      {/* customer info */}
      <div className={styles.customerColumn}>
        {customerOrders.customerName}
      </div>
      {/* orders */}
      {week.map((day, i) => {
        // find the order
        const dayOrders = findOrderOfDay(customerOrders, day);
        return (
          <div
            key={i}
            className={styles.orderColumn}
          >
            {dayOrders.length > 0 ? 
            dayOrders.map(order => 
              <OrderItem order={order} />)
            : (
            <div className={styles.noMenu}>없음</div>
            )}
          </div>
        )
      })}
    </div>
  );
}

const OrderItem = ({ order }) => {
  const {
    date, supplierName, menuName, pickupTime, orderQty 
  } = order;
  
  return (
    <div className={styles.order}>
			<div className={styles.menu}>
				<div className={styles.supplier}>{supplierName}</div>
				<div className={styles.menuTitle}>{menuName}</div>
			</div>
      <div className={styles.pickupTime}>
        {addColon(pickupTime)}
      </div>
      <div className={styles.orderQty}>
				{orderQty}
			</div>
    </div>
  );
}

function addColon(timeString) {
  return timeString ? `${timeString.substring(0, 2)}:${timeString.substring(2)}` :
    '00:00';
}

export default WeeklySchedules;